/**
 * Feature flag value type. Numeric flags are encoded as `number`; boolean flags as `boolean`.
 * Read via the typed `Record` below; pass the same shape back through UpdateModuleRequest.
 */
export type FeatureFlagValue = boolean | number;

/**
 * System Module - mirrors CSC_CORE SystemModuleDto
 */
export interface SystemModuleDto {
  id: number;
  moduleName: string;
  moduleCode: string;
  description: string;
  isEnabled: boolean;
  isUnderMaintenance: boolean;
  allowAdminOverride: boolean;
  maintenanceMessage: string | null;
  featureFlags: Record<string, FeatureFlagValue>;
}

/**
 * Request DTO for updating a system module - mirrors CSC_CORE UpdateModuleRequestDto
 */
export interface UpdateModuleRequest {
  isEnabled: boolean;
  isUnderMaintenance: boolean;
  allowAdminOverride: boolean;
  maintenanceMessage: string | null;
  featureFlags?: Record<string, FeatureFlagValue> | null;
}

/**
 * Mirrors the backend's `FlagType` enum. Numeric so the wire format matches
 * the rest of the API (which serializes enums as ints by default — same
 * convention as QuotationStatus / QuotationEventType).
 */
export enum FlagType {
  Boolean = 0,
  Number = 1,
}

/**
 * UI metadata for a single feature flag.
 */
export interface FeatureFlagMetadata {
  key: string;
  label: string;
  description: string;
  type: FlagType;
  defaultValue: FeatureFlagValue;
  /** Numeric flags only. */
  min?: number | null;
  /** Numeric flags only. */
  max?: number | null;
}

/**
 * Feature flag metadata grouped by module code.
 */
export type FeatureFlagMetadataMap = Record<string, FeatureFlagMetadata[]>;
